import { Component } from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import VehicleSelect from 'components/organisms/wizard/vehicleSelect';
import VehicleCharacteristics from 'components/organisms/wizard/vehicleCharacteristics';
import ServiceSelect from 'components/organisms/wizard/serviceSelect';
import ServiceDetails from 'components/organisms/wizard/serviceDetails/';
import MaintenancePlans from 'components/organisms/wizard/maintenancePlans/';
import ShiftSelect from 'components/organisms/wizard/shiftSelect/';
import ShiftHours from 'components/organisms/wizard/shiftHours/';
import AdvisorSelect from 'components/organisms/wizard/advisorSelect/';
import PersonalInfo from 'components/organisms/wizard/personalInfo';
import Review from 'components/organisms/wizard/review';
import Congrats from 'components/organisms/wizard/congrats';
import Payment from 'components/organisms/wizard/payment';
import { isEligible as isEligibleForMaintenancePlan } from 'helpers/maintenancePlan.js';

import { fetchList } from 'actions/models';

class Wizard extends Component {
  constructor(props) {
    super(props);

    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);

    this.state = {
      page: 1,
    };

    this.props.fetchModels(this.props.brandId);
  }

  nextPage() {
    window.scrollTo(0, 0);
    this.setState({ page: this.state.page + 1 });
  }

  previousPage() {
    window.scrollTo(0, 0);
    this.setState({ page: this.state.page - 1 });
  }

  componentDidMount() {
    if (!this.props.workshop) {
      return window.location.replace('/');
    }
  }

  goToPage(page) {
    this.setState({ page: page });
  }

  render() {
    let { page } = this.state;
    const { maintenancePlanAvailable, maintenance_plan_id } = this.props;

    if (page === 1) {
      this.state.serviceCategories = [];
    }

    let pageNumber = 1;

    return (
      <div>
        {page === pageNumber++ && (
          <VehicleSelect
            onSubmit={this.nextPage}
            isFetching={this.props.isFetching}
            models={this.props.models}
          />
        )}

        {page === pageNumber++ && (
          <VehicleCharacteristics
            onSubmit={this.nextPage}
            parameters={this.props.parameters}
            previousPage={this.previousPage}
          />
        )}

        {page === pageNumber++ && (
          <ServiceSelect onSubmit={this.nextPage} previousPage={this.previousPage} />
        )}

        {page === pageNumber++ && (
          <ServiceDetails onSubmit={this.nextPage} previousPage={this.previousPage} />
        )}

        {page === pageNumber++ && (
          <ShiftSelect onSubmit={this.nextPage} previousPage={this.previousPage} />
        )}

        {page === pageNumber++ && (
          <ShiftHours onSubmit={this.nextPage} previousPage={this.previousPage} />
        )}

        {page === pageNumber++ && (
          <AdvisorSelect onSubmit={this.nextPage} previousPage={this.previousPage} />
        )}

        {page === pageNumber++ && (
          <PersonalInfo onSubmit={this.nextPage} previousPage={this.previousPage} />
        )}

        {this.eligibleForMaintenancePlan() && page === pageNumber++ && (
          <MaintenancePlans onSubmit={this.nextPage} previousPage={this.previousPage} />
        )}

        {page === pageNumber++ && (
          <Review
            onSubmit={this.nextPage}
            success={this.nextPage}
            goToPage={this.goToPage.bind(this)}
          />
        )}

        {maintenancePlanAvailable && maintenance_plan_id > 0 && page === pageNumber++ && (
          <Payment />
        )}

        {page === pageNumber++ && <Congrats />}
      </div>
    );
  }

  eligibleForMaintenancePlan() {
    const { maintenancePlanContracted, maintenancePlanAvailable, services } = this.props;

    if (!maintenancePlanAvailable || maintenancePlanContracted) {
      return false;
    }

    return isEligibleForMaintenancePlan(services, maintenancePlanAvailable);
  }
}

const selector = formValueSelector('shiftRequest');

const mapStateToProps = state => {
  return {
    models: state.models.list,
    parameters: state.models.parameters,
    serviceCategories: state.models.serviceCategories,
    isFetching: state.models.isFetching,
    workshop: selector(state, 'workshop'),
    maintenance_plan_id: selector(state, 'maintenance_plan_id'),
    maintenancePlanAvailable: state.maintenancePlans.available,
    maintenancePlanContracted: state.maintenancePlans.contracted,
    brandId: state.configuration.brand_id,
    services: selector(state, 'services'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchModels: brandId => {
      dispatch(fetchList(brandId));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Wizard);
